import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_SUPPLIER_BY_RISK_LEVEL_QUERY_KEY = '3rd-party-management-fetch-eudr-supplier-by-risk-level';

const RISK_LEVEL_ORDER = ['very_high', 'high', 'medium', 'low'];

const RISK_LEVEL_PROGRESS_COLOR = {
    very_high: 'danger',
    high: 'danger',
    medium: 'warning',
    low: 'success',
};

const HIGH_RISK_KEYS = ['very_high', 'high'];

const useSupplierByRiskLevel = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [EUDR_SUPPLIER_BY_RISK_LEVEL_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchSupplierByRiskLevel();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR supplier by risk level data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            levels: null,
            highAndVeryHighTotal: 0,
        };
    }

    const total = data.reduce((sum, item) => sum + (Number(item.value) || 0), 0);

    const levelsByKey = data.reduce((acc, item) => {
        acc[item.key] = item;
        return acc;
    }, {});

    const levels = RISK_LEVEL_ORDER.map((key) => {
        const item = levelsByKey[key];
        const value = Number(item?.value) || 0;

        return {
            key,
            label: t(item?.label || key),
            value,
            percentage: total > 0 ? Math.round((value / total) * 100) : 0,
            color: RISK_LEVEL_PROGRESS_COLOR[key] || 'secondary',
        };
    });

    const highAndVeryHighTotal = HIGH_RISK_KEYS.reduce((sum, key) => {
        return sum + (Number(levelsByKey[key]?.value) || 0);
    }, 0);

    return {
        ...query,
        levels,
        highAndVeryHighTotal,
    };
};

export default useSupplierByRiskLevel;
